<div mat-dialog-title>
  <div class="flex items-center justify-between h-48">
    <h6>{{ data.user ? 'Edit' : 'Add' }} Multi-Location Administrator</h6>
    <button matIconButton aria-label="Close" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>

<mat-divider class="mx-20!" />

<form [formGroup]="form" (submit)="submitMlAdminForm()">
  <div mat-dialog-content class="overflow-auto custom-thin-scrollbar">
    <section>
      <article class="grid grid-cols-3 gap-20">
        <mat-form-field [ngClass]="{ 'pb-15': username.hasError('usernameDuplicate') }">
          <mat-label>Username</mat-label>
          <input formControlName="username" matInput (change)="removeDuplicateError()" />
          @if (username.hasError('required')) {
            <mat-error> Username is <strong>required</strong> </mat-error>
          }
          @if (username.hasError('usernameDuplicate')) {
            <mat-error> This username already exists </mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <mat-label>First Name</mat-label>
          <input formControlName="firstName" matInput />
          @if (firstName.hasError('required')) {
            <mat-error> First Name is <strong>required</strong> </mat-error>
          }
        </mat-form-field>

        <mat-form-field>
          <mat-label>Last Name</mat-label>
          <input formControlName="lastName" matInput />
          @if (lastName.hasError('required')) {
            <mat-error> Last Name is <strong>required</strong> </mat-error>
          }
        </mat-form-field>
      </article>
      <article class="grid grid-cols-3 gap-20">
        <mat-form-field class="col-span-2">
          <mat-label>Email</mat-label>
          <input formControlName="email" matInput />
          @if (email.invalid && !email.hasError('required')) {
            <mat-error class="mat-error"> Please enter a valid email address </mat-error>
          }
          @if (email.hasError('required')) {
            <mat-error> Email is <strong>required</strong> </mat-error>
          }
        </mat-form-field>

        <mat-form-field>
          <mat-label>Phone Number</mat-label>
          <input formControlName="phone" matInput />
          @if (phone.touched && phone.hasError('phoneInvalid')) {
            <mat-error> {{ getErrorMessage(phone.errors) }} </mat-error>
          }
        </mat-form-field>
      </article>
    </section>

    <section>
      <app-mladmin-modal-repairer-sites
        [userRepairerSite]="data.user?.repairerSites"
        (repairerSiteSelected)="repairerSiteSelected = $event"></app-mladmin-modal-repairer-sites>
    </section>
  </div>

  <mat-divider class="mx-20!" />

  <mat-dialog-actions>
    <button matButton="elevated" class="charcoal-button" mat-dialog-close>CANCEL</button>
    <button
      [disabled]="form.invalid || mlAdminService.loadingMlAdminUser()"
      matButton="elevated"
      class="red-button"
      type="submit">
      SAVE
    </button>
  </mat-dialog-actions>
</form>
